import { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import useRolePermissions from '@/hooks/admin/shared/useRolePermissions';
import PropertiesSubNav from './PropertiesSubNav';
import PropertiesListView, { PropertiesListViewRef } from './PropertiesListView';
import PropertiesContractsView, { PropertiesContractsViewRef } from './PropertiesContractsView';

type SubTab = 'properties' | 'contracts';

const PropertiesTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('properties');
  const propertiesViewRef = useRef<PropertiesListViewRef>(null);
  const contractsViewRef = useRef<PropertiesContractsViewRef>(null);
  const { canCreate } = useRolePermissions();

  const handleCreate = () => {
    if (activeSubTab === 'properties') {
      propertiesViewRef.current?.createNew();
    } else {
      contractsViewRef.current?.createNew();
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between min-h-10">
          <h2 className="text-2xl font-bold">Propiedades</h2>

          {canCreate && (
            <Button
              onClick={handleCreate}
              className="bg-brand-primary hover:bg-brand-primary-hover flex items-center gap-2"
            >
              <Plus size={16} />
              {activeSubTab === 'properties' ? 'Nueva Propiedad' : 'Nuevo Contrato'}
            </Button>
          )}
        </div>

        <PropertiesSubNav
          activeSubTab={activeSubTab}
          onSubTabChange={setActiveSubTab}
        />
      </div>

      {activeSubTab === 'properties' ? (
        <PropertiesListView ref={propertiesViewRef} />
      ) : (
        <PropertiesContractsView ref={contractsViewRef} />
      )}
    </div>
  );
};

export default PropertiesTab;
